module.exports = __webpack_public_path__ + "img/cloudflarelogo.5dffb9ee.png";